import React from 'react';
import { useTranslation } from "react-i18next";

import { ReactComponent as InfoIcon } from 'assets/icons/ico_info_circle_blue.svg';
import ConnectedCommunitiesItem from './connectedCommunitiesItem';

const ConnectedCommunitiesTable = ({ connectedCommunities, setConnectedCommunities }) => {
    const { t } = useTranslation();

    if (!connectedCommunities) {
        return (null);
    }

    return (
        <>
            <div className="-mr-6 -ml-6 airpark-scroll overflow-x-scroll">
                <table className="table-auto w-full">
                    <thead className=''>
                        <tr className="text-left bg-airpark-gray-300 h-11">
                            <th className="pl-6 whitespace-nowrap">{t('connectedCommunitiesTable.communityName')}</th>
                            <th className="pl-6 whitespace-nowrap">{t('connectedCommunitiesTable.connectedCommunityName')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {connectedCommunities && connectedCommunities.length > 0 && connectedCommunities.map((connectedCommunity, i) => {
                            return (<ConnectedCommunitiesItem 
                                        key={i} 
                                        communityConnection={connectedCommunity} 
                                        communityConnections={connectedCommunities} 
                                        setCommunityConnections={setConnectedCommunities} />)
                        })}
                        {connectedCommunities && connectedCommunities.length < 1 &&
                            <tr className="h-16">
                                <td className="text-center" colSpan={4}>
                                    <div className="flex pl-6 gap-3 flex-row items-center justify-left">
                                        <InfoIcon className="h-6 w-6" />
                                        <span>{t('connectedCommunitiesTable.noConnectedCommunities')}</span>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default ConnectedCommunitiesTable;